"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classificationService = void 0;
var _http = _interopRequireDefault(require("@/config/http"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var classificationService = exports.classificationService = {
  fetchClassifications: fetchClassifications
};
function fetchClassifications(id) {
  return _http.default.get('/classifications', {
    params: {
      productId: id
    }
  });
}